import { digObject } from '@domain-group/javascript-utils'

import { Box, NumberWithIconGrid } from '@domain-group/suit-theme'

import AdminUserIcon from '@components/Icons/AdminUserIcon'
import AgentUserIcon from '@components/Icons/AgentUserIcon'
import CampaignIcon from '@components/Icons/CampaignIcon'
import OrderIcon from '@components/Icons/OrderIcon'

import useAgencyRelatedEntityCounts from '@hooks/useAgencyRelatedEntityCounts'

import { AgencyModel } from '@models/types'

interface AgencyImagesProps {
  agency: AgencyModel,
}

const AgencyStatistics = (props: AgencyImagesProps) => {
  const { agency } = props

  const { agencyRelatedEntityCounts, loading } = useAgencyRelatedEntityCounts(
    agency,
    {
      entityKeys: ['agents', 'campaigns', 'office_administrators', 'orders'],
      performHttpRequests: true,
    },
  )

  // @ts-expect-error TS2345
  const adminUsersCount = digObject(agencyRelatedEntityCounts, 'office_administrators', 0)
  // @ts-expect-error TS2345
  const agentUsersCount = digObject(agencyRelatedEntityCounts, 'agents', 0)
  // @ts-expect-error TS2345
  const campaignCount = digObject(agencyRelatedEntityCounts, 'campaigns', 0)
  // @ts-expect-error TS2345
  const ordersCount = digObject(agencyRelatedEntityCounts, 'orders', 0)

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderBottomLeftRadius={5}
      borderBottomRightRadius={5}
      borderColor="lineColor"
      borderTop="none"
      flexDirection="column"
      marginBottom="large"
    >
      {!loading && (
        <NumberWithIconGrid>
          <NumberWithIconGrid.Item
            disableHover
            icon={<CampaignIcon width={40} height={40} fillColor="#8C8C8E" />}
            label="Campaigns"
            value={campaignCount}
          />

          <NumberWithIconGrid.Item
            disableHover
            icon={<OrderIcon width={40} height={40} fillColor="#8C8C8E" />}
            label="Orders"
            value={ordersCount}
          />

          <NumberWithIconGrid.Item
            disableHover
            icon={<AdminUserIcon width={40} height={40} fillColor="#8C8C8E" />}
            label="Admin Users"
            value={adminUsersCount}
          />

          <NumberWithIconGrid.Item
            disableHover
            icon={<AgentUserIcon width={40} height={40} fillColor="#8C8C8E" />}
            label="Agent Users"
            value={agentUsersCount}
          />
        </NumberWithIconGrid>
      )}
    </Box>
  )
}

export default AgencyStatistics
